import { css } from '@emotion/react'
import { ITableProps } from 'common-components'
import { CertificationType } from '@types'
import { Loader } from '@components/utils'

import Header from './Header'
import CertificationsTable from './CertificationsTable'

export type CertificationsPropsType = {
  certifications: CertificationType[]
  isLoading?: boolean
  tableProps?: Partial<ITableProps<CertificationType>>
}
function Certifications({ certifications, isLoading, tableProps }: CertificationsPropsType) {
  return (
    <div>
      <Header />
      <div
        css={css`
          margin-top: 16px;
        `}
      >
        {isLoading && <Loader />}
        {!isLoading && (
          <CertificationsTable certifications={certifications} tableProps={tableProps} />
        )}
      </div>
    </div>
  )
}

export default Certifications
